import siteConfig from "../siteConfig";

const catalog = [
  {
    name: "Ochre & Forest Shape Study Print",
    category: "Art + Prints",
    price: 88,
    stock: 14,
    material: "230gsm acid-free matte paper",
    size: ["A3 · 29.7 × 42cm"],
    colors: ["Rust + Ochre + Forest"],
    use: "Unframed wall art for dry indoor rooms.",
    description: "An original geometric study inspired by cheese shapes, printed in rust, ochre and forest green on warm-white matte stock. Its clean A3 format suits kitchens, dining corners and compact gallery walls without relying on readable slogans.",
    care: "Handle with clean, dry hands; frame behind glazing; keep away from steam, direct sun and damp walls.",
    warning: "Supplied unframed. Paper edges can crease; this is decorative art, not a food-contact item.",
  },
  {
    name: "Coral Gesture Abstract Print",
    category: "Art + Prints",
    price: 92,
    stock: 9,
    material: "230gsm matte paper with pigment print",
    size: ["A3 · 29.7 × 42cm"],
    colors: ["Coral + Blush"],
    use: "Colour accent for bedrooms, halls or living spaces.",
    description: "A loose coral-and-blush composition reproduced from broad painted gestures. Visible brush texture gives the flat print a handmade energy while the warm palette remains easy to place with timber, linen and neutral walls.",
    care: "Display indoors, avoid prolonged direct sunlight, and dust the frame rather than the paper surface.",
    warning: "Supplied unframed. Colour may appear warmer or cooler under different screens and room lighting.",
  },
  {
    name: "Burgundy Arch & Goblet Print",
    category: "Art + Prints",
    price: 96,
    stock: 18,
    material: "230gsm archival matte paper",
    size: ["A3 · 29.7 × 42cm"],
    colors: ["Vermilion + Burgundy"],
    use: "Decorative print for dining and entertaining areas.",
    description: "A retro-inspired arch and goblet composition in vermilion and deep burgundy. The artwork is entirely graphic, with no copied lettering, and is sized to sit comfortably above a drinks trolley or within a mixed picture wall.",
    care: "Keep dry and flat until framing; use acid-free mounting corners; avoid adhesive directly on the sheet.",
    warning: "Decorative paper product only. Keep away from open flames and cooking splashes.",
  },
  {
    name: "Cobalt Loop Abstract Print",
    category: "Art + Prints",
    price: 90,
    stock: 11,
    material: "Textured 230gsm art paper",
    size: ["A3 · 29.7 × 42cm"],
    colors: ["Cobalt + Burnt Red"],
    use: "Expressive wall art for a study, hallway or reading corner.",
    description: "Cobalt loops sweep across a softly textured ivory ground, punctuated by fine burnt-red marks. The design retains the spontaneous rhythm of handwriting while using no legible phrase or third-party artwork.",
    care: "Frame for protection, keep below 60% relative humidity where practical, and do not wipe the printed face.",
    warning: "Unframed sheet; small variations in trim and print registration are normal production tolerances.",
  },
  {
    name: "Leaf Relief Printing Workshop",
    category: "Books + Events",
    price: 180,
    stock: 8,
    material: "In-person workshop admission and shared print tools",
    size: ["One participant"],
    colors: ["Session details confirmed after order review"],
    use: "Beginner-friendly introduction to relief printing from botanical forms.",
    description: "A practical session covering simple block preparation, safe tool handling, ink rolling and a first botanical print. The checkout records a request for one place; the date, venue, accessibility arrangements and final attendance confirmation must be agreed by customer care before the booking is treated as complete.",
    care: "Wear clothes suitable for water-based ink and follow the facilitator's tool and cleanup instructions.",
    warning: "Carving tools are sharp. Participants who need supervision or an accessibility adjustment must contact customer care before attending.",
  },
  {
    name: "Natural Oval Jute Border Rug",
    category: "Rugs + Textiles",
    price: 159,
    stock: 7,
    material: "Braided natural jute with woven cotton edge",
    size: ["60 × 90cm", "60 × 145cm"],
    colors: ["Natural + Charcoal"],
    use: "Low-traffic dry areas such as an entry, bedside or reading corner.",
    description: "A low-profile oval rug with concentric braided jute and a charcoal edge that visually anchors the natural fibre. The firm construction suits dry indoor floors and layers easily beneath compact furniture.",
    care: "Vacuum on low suction without a beater bar; rotate regularly; blot spills immediately; professional dry cleaning only.",
    warning: "Use a suitable non-slip underlay. Natural fibre may shed, darken when wet and vary in tone; not for bathrooms or outdoor use.",
  },
  {
    name: "Mineral Diamond Flatweave Rug",
    category: "Rugs + Textiles",
    price: 180,
    stock: 0,
    material: "80% wool, 20% cotton flatweave",
    size: ["120 × 180cm"],
    colors: ["Terracotta + Indigo + Sand + Olive"],
    use: "Decorative floor covering for dry living and dining areas.",
    description: "A reversible-feeling flatweave with an original stepped geometric pattern in muted mineral colours. Wool provides resilient texture while the cotton warp keeps the rug comparatively light and easy to reposition.",
    care: "Vacuum gently from both directions, rotate to balance wear, and use a professional rug cleaner for stains.",
    warning: "Always use an underlay. Loose fibres and weave irregularities are expected; keep away from sparks, damp floors and unsupervised pets that chew fibres.",
  },
  {
    name: "Honey Botanical Tufted Floor Pad",
    category: "Cushions + Throws",
    price: 149,
    stock: 16,
    material: "Cotton cover with recycled-cotton filling",
    size: ["60 × 100cm"],
    colors: ["Honey + Dusty Rose"],
    use: "Extra cushioning on a bench or dry indoor floor.",
    description: "A slim biscuit-tufted pad with an original honey-and-rose botanical print. Recycled-cotton filling creates relaxed, slightly uneven loft that works well for occasional seating and layered soft furnishing.",
    care: "Spot clean with a barely damp cloth, air flat, vacuum gently and avoid machine washing or tumble drying.",
    warning: "Not a sleeping mattress or infant product. Keep dry, supervise floor use and keep away from flames.",
  },
  {
    name: "Rose & Blue Striped Floor Pad",
    category: "Cushions + Throws",
    price: 139,
    stock: 12,
    material: "Cotton cover with recycled-cotton filling",
    size: ["60 × 100cm"],
    colors: ["Old Rose + Slate Blue + Warm White"],
    use: "Bench pad, window-seat layer or occasional floor cushion.",
    description: "Narrow faded stripes run across a softly channel-tufted cotton pad. The restrained old-rose, slate-blue and warm-white palette is designed for casual seating where a full-depth cushion would feel too bulky.",
    care: "Shake and rotate regularly; spot clean only; dry fully away from direct heat before reuse.",
    warning: "Not designed for overnight sleep, cots or outdoor storage. Colour transfer is possible when damp.",
  },
  {
    name: "Silver-Wrapped Fish Chocolate Trio",
    category: "Pantry",
    price: 58,
    stock: 24,
    material: "Milk chocolate in foil and paper gift packaging",
    size: ["3 pieces · 45g total"],
    colors: ["Silver Foil + Deep Blue Box"],
    use: "Novelty food gift for chocolate eaters.",
    description: "Three fish-shaped milk chocolates individually wrapped in silver foil and presented in a plain deep-blue paper box. The moulded scale detail makes a playful small gift without using copied packaging or third-party marks.",
    care: "Leave each piece wrapped until needed and keep the box in a shaded, low-humidity cupboard without strongly scented foods; the delivered batch label governs ingredients and date marking.",
    warning: "Food allergen and ingredient information on the delivered pack controls. May be unsuitable for milk, soy or nut allergies; small pieces can be a choking risk.",
  },
  {
    name: "Faceted Sand-Glaze Stoneware Planter",
    category: "Pots + Vases",
    price: 98,
    stock: 13,
    material: "Hand-pressed glazed stoneware",
    size: ["Small · Ø12 × H10cm", "Large · Ø16 × H13cm"],
    colors: ["Sandstone"],
    use: "Indoor cachepot or dry storage vessel.",
    description: "A rounded stoneware pot with softly pressed facets and a warm speckled sandstone glaze. The irregular surface gives foliage and shelves texture while the compact sizes remain practical for small interiors.",
    care: "Wipe with a soft damp cloth and dry; use an inner pot or saucer and check for moisture beneath after watering.",
    warning: "No drainage hole. Waterproofing is not guaranteed indefinitely; avoid food use, impact and frost.",
  },
  {
    name: "Velvet Fringe Lumbar Cushion",
    category: "Cushions + Throws",
    price: 168,
    stock: 6,
    material: "Cotton velvet cover with feather inner",
    size: ["50 × 70cm"],
    colors: ["Melon", "Forest", "Sapphire", "Pale Rose"],
    use: "Decorative support cushion for indoor seating.",
    description: "A generously proportioned cotton-velvet cushion finished with a narrow flat fringe. The feather inner settles into a relaxed profile and can be reshaped for a sofa, reading chair or bed layer.",
    care: "Plump and rotate; vacuum with an upholstery head; professional clean only; brush pile in one direction after drying.",
    warning: "Contains feathers and is not suitable for anyone with a relevant sensitivity. Keep away from fire and prolonged direct sun.",
  },
  {
    name: "Weathered Zinc Display Tray",
    category: "Kitchen + Dining",
    price: 118,
    stock: 17,
    material: "Zinc-finished steel",
    size: ["Ø38 × H3cm"],
    colors: ["Weathered Zinc"],
    use: "Dry serving, tabletop grouping or plant-pot catch tray with an added liner.",
    description: "A shallow round tray with a rolled rim and naturally mottled zinc finish. The broad surface gathers glasses, condiments or small objects while the low edge keeps the silhouette light.",
    care: "Wipe promptly after use, dry thoroughly and avoid abrasives, dishwashers and acidic foods directly on the metal.",
    warning: "Not certified for direct food contact. Do not use in an oven or over heat; stop using if a sharp edge or severe corrosion develops.",
  },
  {
    name: "Mustard Reactive-Glaze Jar Vase",
    category: "Pots + Vases",
    price: 128,
    stock: 0,
    material: "Wheel-thrown glazed stoneware",
    size: ["Ø12 × H13cm"],
    colors: ["Antique Mustard"],
    use: "Small flower vase or dry utensil holder.",
    description: "A squat jar vase with rounded shoulders, a small mouth and a mustard reactive glaze. Throwing lines, speckles and glaze pooling make each piece visually individual without affecting ordinary display use.",
    care: "Hand wash, dry the unglazed foot, change flower water often and place on a protective coaster.",
    warning: "Ceramic is breakable and may mark delicate surfaces when wet. Not guaranteed for food storage or extreme temperature change.",
  },
  {
    name: "Salted Pretzel Caramel Chocolate Bar",
    category: "Pantry",
    price: 68,
    stock: 21,
    material: "Milk chocolate with pretzel pieces and salted caramel",
    size: ["80g"],
    colors: ["Plain Paper Wrap"],
    use: "Sweet snack or small food gift.",
    description: "A segmented milk-chocolate bar scattered with crisp pretzel fragments and salted caramel pieces. The mix balances creamy chocolate, toasted crunch and a light salt note in a compact sharing format.",
    care: "Keep sealed, cool and dry; avoid refrigeration unless necessary; refer to the delivered wrapper for best-before information.",
    warning: "Contains or may contain milk, gluten, soy and nuts depending on the batch label. Caramel can be hard; supervise young eaters.",
  },
  {
    name: "Abstract-Cover Pocket Book Pair",
    category: "Books + Events",
    price: 119,
    stock: 15,
    material: "Two thread-sewn softback books on uncoated paper",
    size: ["2-volume set · 12 × 18cm each"],
    colors: ["Aubergine + Teal"],
    use: "Compact reading set for travel, gifting or a bedside shelf.",
    description: "Two slim poetry volumes with abstract uncoated covers and exposed thread-sewn bindings. The tactile paper and compact dimensions are designed for short reading sessions and easy carrying without referring to another publisher's titles or authors.",
    care: "Store upright in a dry place, support the spine when opening and keep away from food, drink and direct sun.",
    warning: "Paper edges can bend and ink can transfer if wet. Cover colour may vary slightly between print runs.",
  },
  {
    name: "Cotton & Sisal Soap Pouch",
    category: "Bath + Body",
    price: 49,
    stock: 27,
    material: "70% cotton, 30% sisal",
    size: ["11 × 12.5cm"],
    colors: ["Natural Ecru"],
    use: "Holds a bar or soap ends while providing light body exfoliation.",
    description: "A drawstring cotton-and-sisal pouch that keeps small soap pieces together and creates a textured lathering surface. Its open weave rinses easily and provides a firmer feel than a plain cotton washcloth.",
    care: "Rinse thoroughly after every use, squeeze gently without twisting, hang open to dry and wash before first use.",
    warning: "Do not use on broken, inflamed or highly sensitive skin. Stop if irritation occurs; keep the drawstring away from young children.",
  },
  {
    name: "Aged Pewter Taper Candle Holder",
    category: "Candles + Holders",
    price: 138,
    stock: 10,
    material: "Iron with aged pewter finish",
    size: ["H19.5 × Ø9.5cm"],
    colors: ["Pewter"],
    use: "Indoor support for a correctly fitted standard taper candle.",
    description: "A slender iron holder with a broad round base, softly brushed pewter finish and raised socket. The weight and footprint are intended to create a stable table or mantel silhouette.",
    care: "Dust dry; remove cooled wax carefully; never soak; check the base and socket before every use.",
    warning: "Burn candles only under constant adult supervision on a level heat-resistant surface, away from drafts, children, pets and flammable objects.",
  },
  {
    name: "Speckled Grey Porcelain Espresso Cup",
    category: "Ceramics",
    price: 72,
    stock: 20,
    material: "Glazed porcelain",
    size: ["H5.5 × Ø6cm · 90ml"],
    colors: ["Speckled Grey + White"],
    use: "Single espresso, tasting pour or small condiment portion.",
    description: "A petite handled porcelain cup with a softly speckled grey-white glaze and rounded lip. The compact 90ml capacity is sized for espresso and small pours rather than a full coffee serving.",
    care: "Hand washing is recommended; avoid metal scouring pads and allow hot ceramics to cool before rinsing.",
    warning: "Check for chips or cracks before use. Avoid sudden temperature changes and do not use damaged drinkware.",
  },
  {
    name: "Warm Beige Fluted Stoneware Cup",
    category: "Ceramics",
    price: 78,
    stock: 19,
    material: "Reactive-glazed stoneware",
    size: ["H6.3 × Ø6.2cm · 100ml"],
    colors: ["Warm Beige"],
    use: "Espresso, tea tasting or a small dessert portion.",
    description: "A handleless stoneware cup with vertical fluting, a hand-finished rim and warm beige reactive glaze. The ridged body adds grip while natural glaze variation keeps the quiet form from feeling uniform.",
    care: "Hand wash and dry; warm gradually before very hot drinks; stack only with a soft separator.",
    warning: "Surface and glaze tone vary. Do not expose to direct flame, stovetops or thermal shock; discard if cracked.",
  },
  {
    name: "Deep Green Faceted Glass Candle Holder",
    category: "Candles + Holders",
    price: 108,
    stock: 5,
    material: "Pressed coloured glass",
    size: ["Short · H10cm", "Tall · H15cm"],
    colors: ["Deep Green"],
    use: "Indoor taper-candle support and reflective table accent.",
    description: "A deep-green pressed-glass holder with a faceted base and narrow taper socket. Tiny bubbles and mould lines are visible in the glass and catch low light without added decoration.",
    care: "Wipe with a soft cloth; remove only fully cooled wax; avoid abrasive cleaners and rapid temperature changes.",
    warning: "Glass can break or become hot. Use the correct candle diameter, never leave a flame unattended and stop use if chipped.",
  },
  {
    name: "Natural Woven Bamboo Storage Basket",
    category: "Baskets + Storage",
    price: 148,
    stock: 8,
    material: "Handwoven natural bamboo",
    size: ["Small · Ø28 × H26cm", "Medium · Ø36 × H34cm", "Large · Ø44 × H42cm"],
    colors: ["Natural Bamboo"],
    use: "Dry indoor storage for textiles, toys or lightweight household items.",
    description: "A cylindrical bamboo basket with reinforced rim binding and two wrapped loop handles. The broad cross weave is airy enough for linens while natural colour shifts and small alignment differences reveal the handwoven construction.",
    care: "Dust or wipe nearly dry, air immediately and avoid prolonged moisture, strong sun and overloading.",
    warning: "Not a seat, step, toy box for unsupervised infants or food container. Inspect for split fibres before handling.",
  },
  {
    name: "Hammered Bronze-Tone Bottle Cooler",
    category: "Kitchen + Dining",
    price: 178,
    stock: 4,
    material: "Hammered aluminium with dark bronze finish",
    size: ["H21 × Ø22cm"],
    colors: ["Dark Bronze"],
    use: "Holds a pre-chilled bottle with ice for short table service.",
    description: "A cylindrical aluminium cooler with a dark bronzed surface, lightly hammered texture and two ring handles. The rolled rim and stable base suit table service while the finish keeps condensation marks visually discreet.",
    care: "Hand wash with mild soap, dry at once and avoid dishwashers, salt residue, abrasives and long water exposure.",
    warning: "Not for heating, drinking from or direct food storage. Condensation can make the base and handles slippery; protect delicate tables.",
  },
  {
    name: "Sand-Fleck Stoneware Mug",
    category: "Ceramics",
    price: 128,
    stock: 18,
    material: "Wheel-thrown speckled stoneware",
    size: ["450ml"],
    colors: ["Sandy Fleck + Natural Clay"],
    use: "Generous mug for tea, coffee or other hot and cold drinks.",
    description: "A broad-handled wheel-thrown mug with sandy glaze fading into a tactile unglazed base. Speckled clay, throwing rings and small glaze shifts are part of the individual handmade appearance.",
    care: "Hand wash, dry the unglazed foot and pre-warm gently before adding boiling liquid.",
    warning: "Check for cracks before use; handle may become warm. Avoid direct flame, stovetops, freezers and sudden temperature changes.",
  },
  {
    name: "Sea-Green Stoneware Serving Bowl",
    category: "Ceramics",
    price: 168,
    stock: 11,
    material: "Wheel-thrown glazed stoneware",
    size: ["Ø28 × H8cm"],
    colors: ["Oat + Muted Sea Green"],
    use: "Serving salads, fruit or shared side dishes at the table.",
    description: "A shallow serving bowl with warm oat exterior, muted sea-green glazed interior and softly rounded rim. The 28cm span gives shared dishes room while the low profile keeps contents visible and easy to serve.",
    care: "Hand wash, dry fully and protect the base when stacking; avoid abrasive utensils and long soaking.",
    warning: "Not for stovetop, broiler or direct flame. Thermal shock and impact can crack stoneware; stop using if damaged.",
  },
];

const productData = catalog.map((product, index) => {
  const id = index + 1;
  const stem = `/img/products/product-${String(id).padStart(2, "0")}`;
  const images = [`${stem}-1.jpg`, `${stem}-2.jpg`];
  return {
    id,
    brand: siteConfig.brandName,
    tags: [product.category.toLowerCase(), product.material.toLowerCase(), product.use.toLowerCase()],
    ...product,
    image: images[0],
    images,
    attributes: { material: product.material, size: product.size.join(", ") },
    Features: [product.use, product.material, product.size.join(" / "), product.care],
  };
});

export default productData;
